import { SAMPLE_COMPANIES } from '../../../components/FrostedGate/sample-companies';
import {
  createFinanceRoundDataModel,
  IFinanceRoundDataModel,
} from '../../../data-models/finance-round.data-model';
import { IRoundTransactionRow } from './RoundTransactionGrid';

export const PREVIEW_COMPANY = SAMPLE_COMPANIES[2];

/** Three financings for the frosted Deals tab, newest first, with fictional co-investors. */
export const PREVIEW_ROUNDS: IFinanceRoundDataModel[] = [
  createFinanceRoundDataModel({
    id: -1,
    companyId: PREVIEW_COMPANY.id,
    name: 'Series C',
    roundDate: '2026-05-14',
    raiseAmount: 45_000_000,
    preMoneyValuation: 255_000_000,
    postMoneyValuation: 300_000_000,
    roundDilution: 0.15,
    newSharesIssued: 3_200_000,
    fullyDilutedShares: 21_400_000,
    ownershipPercentage: 0.084,
    totalHolders: 9,
    leadInvestors: ['Ridgeback Partners'],
    coInvestors: ['Growth Fund IV', 'Bluewater Capital', 'Northstar Ventures', 'Halcyon Growth'],
    dealSecurities: [
      { securityName: 'Series C Preferred', sharesIssued: 3_000_000, pricePerShare: 14.06 },
      { securityName: 'Series C-1 Preferred', sharesIssued: 200_000, pricePerShare: 14.06 },
    ],
  }),
  createFinanceRoundDataModel({
    id: -2,
    companyId: PREVIEW_COMPANY.id,
    name: 'Series B',
    roundDate: '2024-09-30',
    raiseAmount: 18_000_000,
    preMoneyValuation: 82_000_000,
    postMoneyValuation: 100_000_000,
    roundDilution: 0.18,
    newSharesIssued: 2_600_000,
    fullyDilutedShares: 14_900_000,
    ownershipPercentage: 0.061,
    totalHolders: 6,
    leadInvestors: ['Growth Fund IV'],
    coInvestors: ['Bluewater Capital'],
    dealSecurities: [{ securityName: 'Series B Preferred', sharesIssued: 2_600_000, pricePerShare: 6.92 }],
  }),
  createFinanceRoundDataModel({
    id: -3,
    companyId: PREVIEW_COMPANY.id,
    name: 'Seed',
    roundDate: '2022-03-15',
    raiseAmount: 3_500_000,
    preMoneyValuation: 12_000_000,
    postMoneyValuation: 15_500_000,
    roundDilution: 0.226,
    newSharesIssued: 1_900_000,
    fullyDilutedShares: 8_400_000,
    ownershipPercentage: 0.032,
    totalHolders: 4,
    leadInvestors: ['Bluewater Capital'],
    dealSecurities: [{ securityName: 'Seed Preferred', sharesIssued: 1_900_000, pricePerShare: 1.84 }],
  }),
];

export const PREVIEW_STAGE_LABELS: Record<number, string> = {
  [-1]: 'Series C',
  [-2]: 'Series B',
  [-3]: 'Seed',
};

/** Stage chips per round; the ids only pick a palette entry, which needs a positive number. */
export const PREVIEW_STAGES: Record<number, { id: number; label: string }> = {
  [-1]: { id: 3, label: 'Series C' },
  [-2]: { id: 2, label: 'Series B' },
  [-3]: { id: 1, label: 'Seed' },
};

export const PREVIEW_TRANSACTION_ROWS: IRoundTransactionRow[] = [
  {
    date: '2026-05-14',
    transactionType: 'Stock Issuance',
    security: 'Series C Preferred',
    shares: 355_618,
    amountInvested: 5_000_000,
    proceeds: null,
    fund: 'Growth Fund IV',
  },
  {
    date: '2026-05-14',
    transactionType: 'Stock Issuance',
    security: 'Series C Preferred',
    shares: 106_685,
    amountInvested: 1_500_000,
    proceeds: null,
    fund: 'Opportunity Fund II',
  },
];

/** The highest price per share among the round's securities, as the live card derives from transactions. */
export function previewHighestPps(round: IFinanceRoundDataModel): number | null {
  const prices = (round.dealSecurities ?? []).map((security) => security.pricePerShare ?? 0);
  return prices.length > 0 ? Math.max(...prices) : null;
}
